import { SyntheticEvent } from 'react';
import { TableColumn } from '../../types/commonTypes';
import { Popper } from '../Popper';
import { Checkbox } from '../Checkbox';

interface Props {
  anchorElement?: Element | null;
  filteredColumns: TableColumn[];
  loading: boolean;
  onClose(): void;
  open: boolean;
  setFilteredColumns(columns: TableColumn[]): void;
}

export const ColumnFilterMenu = ({
  anchorElement = null,
  filteredColumns,
  loading,
  onClose,
  open,
  setFilteredColumns,
}: Props) => {
  const handleChange = (event: SyntheticEvent) => {
    event.stopPropagation();

    const columns = filteredColumns.slice();
    const column = columns.find(
      (c) => c.name === (event.target as HTMLInputElement).name
    );

    if (column) {
      column.isHidden = !(event.target as HTMLInputElement).checked;
      setFilteredColumns(columns);
    }
  };

  return (
    <Popper
      anchorEl={anchorElement}
      clickAway
      onClose={onClose}
      isVisible={open}
      placement="bottom"
      color="card"
      showArrow
    >
      <ul className="max-h-[400px] overflow-y-auto">
        {filteredColumns
          .filter((c) => c.canColumnFilter ?? true)
          .map((col) => {
            return (
              <li key={col.name} className="px-6 py-2">
                <Checkbox
                  checked={!col.isHidden}
                  disabled={loading}
                  color="primary"
                  name={col.name}
                  onChange={handleChange}
                  label={col.name}
                />
              </li>
            );
          })}
      </ul>
    </Popper>
  );
};
